module.exports = __webpack_public_path__ + "static/media/logo-colinas.0b00d622.png";